import React, { Component } from 'react';

class SkinStories extends Component {
	render() {
		return (
			 <section className="instagram">
				<div className="pss-container">
					<h1 className="instagram__title">Skin Stories</h1>
					<div className="pss-images-row-top">
						<div className="pst-image pst-image-1 d-none d-md-block">
							<div className="pst-insta-wrap product-2">
								<img className="svg" src="/images/instagram.svg" />
							</div>
						</div>
						<div className="pst-image pst-image-2">
							<img src="/images/instagram/ss1.png" />
						</div>
						<div className="pst-image pst-image-3">
							<img src="/images/instagram/ss2.png" />
						</div>
					</div>
					<div className="pss-images-row-bottom">
						<div className="psb-image psb-image-1">
							<img src="/images/instagram/ss3.png" />
							<div className="pst-insta-wrap d-block d-md-none">
								<img className="svg" src="/images/instagram.svg" />
							</div>
						</div>
						<div className="psb-image psb-image-2">
							<img src="/images/instagram/ss4.png" />
							<div className="pss-text  d-none d-md-block">
								<h1 className="text">“Life after Yours is simple, it's lightweight. The next day I wake up with my skin feeling soft.”</h1>
								<p className="name">Julia, Singapore</p>
							</div>
						</div>
						<div className="psb-image psb-video">
							<div className="psb-video-wrap">
								<img src="/images/instagram/ss5.png" />
							</div>
						</div>
						<div className="pss-text d-block d-md-none">
							<h1 className="text">“Life after Yours is simple, it's lightweight. The next day I wake up with my skin feeling soft.”</h1>
							<p className="name">Julia, Singapore</p>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default SkinStories;